// React
import { motion } from "framer-motion";

// Hooks
import { useTranslation } from "react-i18next";

// Lib
import { variants } from "components/__haim/ImportLeads/MainImportContacts";

// Components
import { Box, Button, Card, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import { MaintenanceIllustration } from "assets";

type ExtensionIsNotActiveProps = {
  onBulkMessageDialog?: boolean;
};

export function ExtensionIsNotActive({
  onBulkMessageDialog
}: ExtensionIsNotActiveProps): JSX.Element {
  const { t: translate } = useTranslation();

  const content: JSX.Element = (
    <Box
      sx={{
        p: 4,
        gap: 2,
        display: "grid",
        justifyItems: "center"
      }}
    >
      <MaintenanceIllustration
        sx={{
          height: 240,
          my: {
            xs: 2,
            sm: 4
          }
        }}
      />
      <Typography align="center" variant="h3">
        {translate("importContactsPage.extensionNotActive.title")}
      </Typography>
      <Typography align="center" sx={{ color: "text.secondary" }}>
        {translate("importContactsPage.extensionNotActive.description")}
      </Typography>
      <Button variant="contained" size="large" component={Link} to="/dashboard/whatsAppWeb/status">
        {translate("importContactsPage.extensionNotActive.redirectButton")}
      </Button>
    </Box>
  );

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center"
      }}
      {...(onBulkMessageDialog && {
        component: motion.div,
        ...variants
      })}
    >
      {onBulkMessageDialog ? content : <Card>{content}</Card>}
    </Box>
  );
}
